<template>
  <div id="main_div">
    <!-- home-contain home-right h-100 ml-auto d-flex justify-content-center align-self-center -->

    <section
      id="home"
      class="home home-three vertical-scrolling"
    >
      <div class="container">
        <div class="row row-marg">
          <div class="col-sm-6 col-md-6 align-self-center">
            <div>
              <div class="text-center">
      <img src="../assets/images/testenvlogo.png" alt="Center image" class="img-fluid logosize" />
    </div>
            </div>

            <h2 class="text-white text-center mb-2">
              AWD Auto Repair
            </h2>
            <h5 class="text-white text-center text">
              Fully vetted mechanics you can trust!
            </h5>
          </div>
          <div class="col-6 col-md-4 align-self-center first-step mx-auto">
            <b-form inline>
              <label class="mr-md-2 text-white text-label">Enter repair type</label>
              <b-form-select
                id="inline-form-custom-select-pref"
                v-model="selectedRepair"
                class="mb-2 mr-md-2 mb-md-0"
              >
                <option
                  v-for="repairOption in repairOptions"
                  :key="repairOption"
                >
                  {{ repairOption }}
                </option>
              </b-form-select>
              <b-button
                :disabled="selectedRepair === 'Choose...'"
                variant="success"
                @click="next"
              >
                Next
              </b-button>
            </b-form>
          </div>
        </div>
      </div>
    </section>
    <About />
    <Feature />
    <LatestBlog />
    <Testimonial />
    <Contact_us />
    <Map />
    <js />
  </div>
</template>
<script>
import Testimonial from '../components/testimonial'
import About from '../components/about'
import LatestBlog from '../components/latest_blog'

export default {
  name: 'TestEnv',
  components: { Testimonial, About, LatestBlog },
  data() {
    return {
      isHidden: true,
      selectedRepair: 'Choose...',
      repairOptions: [
        'Mechanical',
        'Collision',
        'Electrical',
        'Rust',
        'Exhaust',
        'Rims And Tires',
        'Choose...',
      ],
    }
  },
  beforeCreate: function() {
    localStorage.setItem('vendor', '5ee2a504fda81a43f8d9bc5d')
    document.body.className = 'home-style three'
  },
  methods: {
    next() {
      this.$store.state.vendor = localStorage.getItem('vendor')
      this.$store.state.userData.selectedRepair = this.selectedRepair
      this.$router.push({
        name: 'VinAndMiles',
      })
    },
  },
}
</script>

<style scoped>
.btn {
  background-color: #02b349;
  border-color: white;
  border-width: thin;
}

.btn:hover {
  background-color: green;
}
.first-step {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* flex-direction: column; */
  height: 100%;
  padding-bottom: 15%;
  padding-top: 15%;
  background-image: url(/static/color/color/color-3/oval_home.png);
  background-size: contain;
  background-repeat: no-repeat;
  width: 40%;
}

.text-label {
  line-height: 1.5;
  font-size: 1.5rem;
  font-weight: 400;
  font-family: Poppins;
}

.row-marg {
  padding-top: 6rem;
}

h2 {
  line-height: 1.5;
  font-size: 2.5rem;
  font-weight: 900;
  font-family: Poppins;
}

h5 {
  text-transform: none;
  font-size: 18px;
  font-weight: 300;
}

.container {
  max-width: 1600px;
}

.logosize{
  height: 30%;
width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/pages/testenv.vue